import { cn } from "./utils";

/**
 * Base focus styles for all focusable elements.
 * This is the SINGLE SOURCE OF TRUTH for focus styling.
 *
 * Links get them globally in index.css; the library's components and the apps' own focusable
 * elements, such as a tile that opens a les, take this class string.
 *
 * Keep in sync with: frontend/packages/ui/src/index.css
 */
export const focusStyles = cn(
  "focus-visible:border-ring focus-visible:ring-ring/50 transition-[color,box-shadow] outline-none focus-visible:ring-[3px]",
);
